/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConversionRate
 */
export interface ConversionRate {
    /**
     * 
     * @type {Currency}
     * @memberof ConversionRate
     */
    freelancerCurrencyCode?: Currency;
    /**
     * 
     * @type {Currency}
     * @memberof ConversionRate
     */
    clientCurrencyCode?: Currency;
    /**
     * 
     * @type {number}
     * @memberof ConversionRate
     */
    rate?: number;
}

/**
 * Check if a given object implements the ConversionRate interface.
 */
export function instanceOfConversionRate(value: object): value is ConversionRate {
    return true;
}

export function ConversionRateFromJSON(json: any): ConversionRate {
    return ConversionRateFromJSONTyped(json, false);
}

export function ConversionRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversionRate {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerCurrencyCode': json['freelancerCurrencyCode'] == null ? undefined : CurrencyFromJSON(json['freelancerCurrencyCode']),
        'clientCurrencyCode': json['clientCurrencyCode'] == null ? undefined : CurrencyFromJSON(json['clientCurrencyCode']),
        'rate': json['rate'] == null ? undefined : json['rate'],
    };
}

export function ConversionRateToJSON(value?: ConversionRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerCurrencyCode': CurrencyToJSON(value['freelancerCurrencyCode']),
        'clientCurrencyCode': CurrencyToJSON(value['clientCurrencyCode']),
        'rate': value['rate'],
    };
}

